import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Workspace from "@/pages/Workspace";
import Login from "@/pages/Login";
import Upgrade from "@/pages/Upgrade";
import HowItWorks from "@/pages/HowItWorks";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { Terms, Privacy } from "@/pages/Legal";
import { AgeGate } from "@/components/legal/AgeGate";
import { AuthProvider } from "@/contexts/AuthContext";

const AppRouter = () => {
  const location = useLocation();
  // OAuth callback — intercept BEFORE rendering routes to prevent race
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Workspace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/upgrade" element={<Upgrade />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-[#0b0f17] text-slate-100">
      <BrowserRouter>
        <AuthProvider>
          <AgeGate />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
